import { Box } from "@chakra-ui/react";

const FloatingCircleDev = () => {
  return (
    <Box
      position="fixed"
      bottom="20px"
      right="20px"
      width="50px"
      height="50px"
      borderRadius="50%"
      bg="blue.500"
      display="flex"
      alignItems="center"
      justifyContent="center"
      boxShadow="lg"
      zIndex="tooltip"
      _hover={{
        bg: "blue.600",
      }}
      onClick={() => {
        //go to colors page 
        window.location.href = "/colors";
      }}
    />
  );
};

export default FloatingCircleDev;
